import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import  "./assets/js/rem.js";
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
    // document.dispatchEvent(new Event('custom-render-trigger'))
  },
}).$mount('#app')
